import React from 'react';

const Now = ({ offset }) => (
    <div
        style={{
            left: offset
        }}
        className="ckp-timetable-now"
    >
        <span className="ckp-timetable-now-top" />
        <span className="ckp-timetable-now-bottom" />
    </div>
);

export default Now;



// WEBPACK FOOTER //
// ./src/components/application/timetable/time/Now.js